export const ProductHandleTypes = {
	pro: 'pro-ctrl-care',
	self: 'self-care',
}
